import { render, staticRenderFns } from "./alliance.vue?vue&type=template&id=29c701ac&scoped=true&"
import script from "./alliance.vue?vue&type=script&lang=js&"
export * from "./alliance.vue?vue&type=script&lang=js&"
import style0 from "./alliance.vue?vue&type=style&index=0&id=29c701ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c701ac",
  null
  
)

export default component.exports